var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[(_vm.patient.name)?_c('p',{staticClass:"subtitle-1 patient-info"},[_vm._v(" Name - "+_vm._s(_vm.patient.name)+" ")]):_vm._e(),(_vm.patient.treatment_startdate != null)?_c('p',{staticClass:"ml-3 subtitle-1 patient-info"},[_vm._v(" Code - "+_vm._s(_vm.patient.reg_unique_code)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }